<h3 class="ui primary header">
  eWallet Withdrawal Request
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<esl-message-toast [(message)]="error"></esl-message-toast>
<esl-message-toast
  [(message)]="success"
  [messageType]="'success'"
></esl-message-toast>

<div class="content">
  <div class="ui basic vertical segment" [ngClass]="{ loading: pending2 }">
    <div
      class="account"
      style="padding: 8px 16px; padding-top: 20px; padding-bottom: 20px"
    >
      <div class="bank">
        <p>
          <strong>Bank:</strong>
          {{
            modal.context.account?.activeBankDetails.bankName ||
              dataToJSON(modal.context.account?.activeBankDetails).bankName
          }}
        </p>
        <div class="ui circular green label">CURRENT</div>
      </div>
      <p>
        <strong>Account Number: </strong
        >{{
          modal.context.account?.activeBankDetails.bankAccountNumber ||
            dataToJSON(modal.context.account?.activeBankDetails)
              .bankAccountNumber
        }}
      </p>
      <p>
        <strong>Account Name: </strong
        >{{
          modal.context.account?.activeBankDetails.bankAccountName ||
            dataToJSON(modal.context.account?.activeBankDetails).bankAccountName
        }}
      </p>
      <p class="blue-text" (click)="changeBankDetails()">Change bank details</p>
    </div>
    <div class="ui form" *ngIf="!modal.context.closeAccount">
      <label
        style="
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: 0px;
          text-align: left;
        "
        >Amount to Withdraw
        <span style="font-size: 10px; font-weight: 400"
          >(Minimum amount to Withdraw is
          {{ modal.context.account?.currencyCode
          }}{{
            modal.context.account?.minWithdrawalAmount | number: ".2-2"
          }}</span
        >)</label
      >
      <div [formGroup]="requestWithdrawalForm" style="margin-top: 8px">
        <app-currencyfmt-number-input
          [currencySymbol]="modal.context.account?.currencyCode"
          [placeholder]="modal.context.account.currencyCode + '1,000'"
          formControlName="amount"
        ></app-currencyfmt-number-input>
      </div>
    </div>
    <div class="account fees">
      <h3 class="ui primary header">Fees & Payments</h3>
      <div *ngIf="modal.context.closeAccount" style="margin-bottom: 24px">
        <p class="desc">Amount to Withdraw</p>
        <p class="amount">
          <strong
            >{{ modal.context.account.currencyCode
            }}{{ formatAmount(getTotal()) }}</strong
          >
        </p>
      </div>
      <div *ngIf="!modal.context.closeAccount" style="margin-bottom: 24px">
        <p class="desc">Amount to Withdraw</p>
        <p class="amount">
          <strong
            >{{ modal.context.account.currencyCode
            }}{{
              requestWithdrawalForm.value.amount
                ? formatAmount(requestWithdrawalForm.value.amount)
                : "0.00"
            }}</strong
          >
        </p>
      </div>
      <div *ngFor="let charge of chargesArray">
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            margin-bottom: 24px;
          "
          *ngIf="
            modal.context.account.currencyShortName === 'DOLLAR'
              ? charge.foreignValue > 0
              : charge.localValue > 0
          "
        >
          <p class="desc" style="margin: 0; padding: 0">
            {{ charge.name }}
            {{
              charge.fixedPercentage === "Percentage"
                ? modal.context.account.currencyShortName === "DOLLAR"
                  ? "(" + charge.foreignValue + "%)"
                  : "(" + charge.localValue + "%)"
                : ""
            }}
          </p>
          <p class="amount" *ngIf="charge.fixedPercentage === 'Percentage'">
            <strong class="amount" *ngIf="modal.context.closeAccount"
              >{{ modal.context.account.currencyCode
              }}{{
                requestWithdrawalForm.value.amount
                  ? formatAmount(
                      getClosingChargesFigure(
                        modal.context.account.currencyShortName === "DOLLAR"
                          ? charge.foreignValue
                          : charge.localValue
                      )
                    )
                  : "0.00"
              }}</strong
            >
            <strong class="amount" *ngIf="!modal.context.closeAccount"
              >{{ modal.context.account.currencyCode
              }}{{
                requestWithdrawalForm.value.amount
                  ? formatAmount(
                      getChargesFigure(
                        modal.context.account.currencyShortName === "DOLLAR"
                          ? charge.foreignValue
                          : charge.localValue
                      )
                    )
                  : "0.00"
              }}</strong
            >
          </p>
          <p class="amount" *ngIf="charge.fixedPercentage === 'Fixed'">
            <strong class="amount"
              >{{ modal.context.account.currencyCode
              }}{{
                formatAmount(
                  modal.context.account.currencyShortName === "DOLLAR"
                    ? charge.foreignValue
                    : charge.localValue
                )
              }}</strong
            >
          </p>
        </div>
      </div>
      <div class="ui divider"></div>
      <div>
        <p>Total</p>
        <p *ngIf="modal.context.closeAccount" class="total">
          <strong class="total"
            >{{ modal.context.account.currencyCode
            }}{{
              requestWithdrawalForm.value.amount
                ? formatAmount(requestWithdrawalForm.value.amount)
                : "0.00"
            }}</strong
          >
        </p>
        <p *ngIf="!modal.context.closeAccount" class="total">
          <strong class="total"
            >{{ modal.context.account.currencyCode
            }}{{ formatAmount(getTotal()) }}</strong
          >
        </p>
      </div>
      <div class="ui divider"></div>
      <div>
        <p
          class="desc"
          style="
            font-family: Roboto;
            font-size: 12px;
            font-weight: 700;
            line-height: 18px;
            letter-spacing: 0em;
            text-align: left;
          "
        >
          Balance After Withdrawal:
          <span
            style="
              font-family: Roboto;
              font-size: 12px;
              font-weight: 400;
              line-height: 18px;
              letter-spacing: 0em;
              text-align: left;
            "
            *ngIf="modal.context.closeAccount"
            >{{ modal.context.account.currencyCode }}
            {{
              formatAmount(
                modal.context.account?.balance -
                  requestWithdrawalForm.value.amount
              )
            }}</span
          >
          <span
            *ngIf="!modal.context.closeAccount"
            style="
              font-family: Roboto;
              font-size: 12px;
              font-weight: 400;
              line-height: 18px;
              letter-spacing: 0em;
              text-align: left;
            "
            >{{ modal.context.account.currencyCode }}
            {{
              formatAmount(modal.context.account?.balance - getTotal())
            }}</span
          >
        </p>
      </div>
    </div>
  </div>

  <div class="actions" style="background: transparent; border: none">
    <button class="ui basic primary button" (click)="modal.deny(undefined)">
      Back
    </button>
    <button
      class="ui primary button"
      [ngClass]="{ loading: pending2 }"
      (click)="submit()"
      autofocus
      [disabled]="
        !requestWithdrawalForm.value.amount || pending2 || checkBalance()
      "
    >
      Submit
    </button>
  </div>
</div>
